import {push} from 'connected-react-router';
import {LocationDescriptorObject} from 'history';
import {Component} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import {Dispatch} from 'redux';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PageHeader from '../../../../components/page-header/page-header';
import {RouteUrl} from '../../../../routes';
import {ApplicationState} from '../../../../store';
import {FleetCustomer} from '../../../../store/fleet-customers';
import * as layoutActions from '../../../../store/layout/actions';
import {FleetCustomerMatchParameters} from '../../../../types/fleet-customer';
import {getReportName, ReportCatalog, ReportCatalogEntry, ReportType} from '../../report-catalog';
import styles from './extended-service-report.module.scss';
import {
    ExtendedInspectionCustomReportParameters,
    ExtendedInspectionReportRequest,
    fetchExtendedServiceReportRequest, ReportPeriodType,
} from '../../../../store/reports';
import {FunctionalLocationsSelectionsControlValue} from '../../../analytics/dashboard-controls/functional-locations-selector/types/functional-locations-selections-control-value';
import {FileType, RequestStatus} from '../../../../store/shared/types';
import ExtendedServiceComponent
    from '../../report-scheduler/popup/report-data-components/extended-service/extended-service.component';

enum InspectionStatus {
    All = 'all',
    NotSeenLastThreeMonths = 'notSeenLastThreeMonths',
    NotSeenLastMonth = 'notSeenLastMonth'
}

class ExtendedServiceReportPage extends Component<AllProps, AllState> {

    constructor(props) {
        super(props);
        const {dispatchToggleSidebar} = this.props;
        dispatchToggleSidebar(true);

        this.state = {
            selectedInspectionStatus: InspectionStatus.All,
        };
    }

    public render(): JSX.Element {
        const { t, location, reportRequestStatus } = this.props;
        const {functionalLocationSelection } = this.state;
        const report: ReportCatalogEntry = new ReportCatalog().getCatalogEntry(ReportType.ExtendedService);

        const isValid = functionalLocationSelection && functionalLocationSelection.value.length > 0;

        return (
            <div className={styles.pageContainer}>
                <PageHeader headerTitle={getReportName(report.type,t)} location={location} bottomComponent={<div />} />
                <div className={styles.pageContent}>
                    <ExtendedServiceComponent
                        periodType={ReportPeriodType.Custom}
                        onCustomParametersChanged={(p) => this.onParametersChanged(p)}
                        onScheduledParametersChanged={() => {}}
                    />
                    <div className={styles.buttons}>
                        <button type='button'
                                className={`${styles.button} ${styles.isNegative}`}
                                disabled={reportRequestStatus?.isInProgress}
                                onClick={() => this.goBack()}>
                            {t('Back')}
                        </button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.ZIP)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download ZIP')}</button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.XLSX)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download XLSX')}</button>
                    </div>
                </div>
            </div>
        );
    }

    private onParametersChanged(parameters: ExtendedInspectionCustomReportParameters) {
        this.setState({
            functionalLocationSelection: parameters.functionalLocationSelection,
            selectedInspectionStatus: parameters.selectedInspectionStatus,
        });
    }

    private download(fileType:FileType) {
        const {selectedInspectionStatus, functionalLocationSelection} = this.state;
        const {dispatchFetchExtendedInspectionReportXpo} = this.props;
        if (functionalLocationSelection && functionalLocationSelection.value.length > 0 && selectedInspectionStatus) {
            dispatchFetchExtendedInspectionReportXpo({
                fileType,
                locations: functionalLocationSelection.value,
                inspectionStatus: selectedInspectionStatus,
            });
        }
    }

    private goBack(): void {
        const { dispatchNavigateTo, fleetCustomer } = this.props;
        dispatchNavigateTo({ pathname: `/${fleetCustomer?.id}${RouteUrl.Reports}` });
    }
}

// eslint-disable-next-line
const mapStateToProps = ({ authentication, reports }: ApplicationState) => ({
    fleetCustomer: authentication.fleetCustomer,
    reportRequestStatus: reports.extendedServiceReportRequestStatus,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    dispatchToggleSidebar: (showSidebar: boolean) => dispatch(layoutActions.toggleSidebar(showSidebar)),
    dispatchNavigateTo: (location: LocationDescriptorObject) => dispatch(push(location)),
    dispatchFetchExtendedInspectionReportXpo: (request: ExtendedInspectionReportRequest) => dispatch(fetchExtendedServiceReportRequest(request)),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ExtendedServiceReportPage));

interface PropsFromState {
    fleetCustomer?: FleetCustomer;
    reportRequestStatus: RequestStatus;
}

interface PropsFromDispatch {
    dispatchNavigateTo: typeof push;
    dispatchToggleSidebar: typeof layoutActions.toggleSidebar;
    dispatchFetchExtendedInspectionReportXpo: typeof fetchExtendedServiceReportRequest;
}

interface OwnProps {
    location: Location;
}

type AllProps = PropsFromState &
    PropsFromDispatch &
    WithTranslation &
    OwnProps &
    RouteComponentProps<FleetCustomerMatchParameters>;

interface OwnState {
    selectedInspectionStatus?: InspectionStatus;
    functionalLocationSelection?: FunctionalLocationsSelectionsControlValue;
}

type AllState = OwnState;
